<script setup>
import { computed } from "vue";
import store from "../store.js";
import { getPrinter } from "../api.js";

const props = defineProps(["selectedPrinter", "selectedIndex", "loading"]);

const selectedId = computed(() => props.selectedPrinter?.name ?? "");

function onPrinterSelect(e) {
    if (e.target.value) {
        getPrinter(e.target.value, props.selectedIndex);
    } else {
        store.addSelectedPrinter(props.selectedIndex, "");
    }
}
</script>

<template>
    <div class="field-group field-group-thumb">
        <label class="field-label sr-only">
            Printer {{ selectedIndex + 1 }}
        </label>

        <img
            :src="
                props.selectedPrinter?.thumbnail ||
                '/assets/img/printer-slider-1-thumb.webp'
            "
            class="field-group-thumb-img d-none d-bp:md-block loading-hide"
            :class="{
                disabled: !selectedId,
                loading: store.loading[selectedIndex],
            }"
            alt=""
        />

        <select
            class="field-select loading-hide"
            :class="{ loading: store.loading[selectedIndex] }"
            @change="onPrinterSelect"
            :disabled="store.loading[selectedIndex]"
        >
            <option value="">Select</option>
            <template
                v-for="printer in store.printers"
                :key="printer.model_number"
            >
                <option
                    v-if="
                        !store.selectedPrinters.some(
                            (element) =>
                                element?.model_number === printer.model_number,
                        ) || selectedId === printer.model_number
                    "
                    :value="printer.model_number"
                    :selected="selectedId === printer.model_number"
                >
                    {{ printer.model_number }}
                </option>
            </template>
        </select>

        <i
            class="loader animate-spin icon-loader loading-show"
            :class="{ loading: store.loading[selectedIndex] }"
            aria-label="Loading"
        ></i>
    </div>
</template>
